import { render, staticRenderFns } from "./AdminSeminar.vue?vue&type=template&id=1ea5a438&"
import script from "./AdminSeminar.vue?vue&type=script&lang=js&"
export * from "./AdminSeminar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports